import React from "react";
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets";
import "../css/commontemplate.css";

export const SansthanVishayi = () => {
  return (
    <>
      <PageHeader title=" संस्थान" path="/about-goshala" name=" goshala" />
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={sansthanImg.s_img01}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>संस्थान उभारणी</h3>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp; श्रीसद्गुरु वेंकटेश दाजीमहाराजांच्या निर्याणानंतर श्रीसद्गुरु वेंकटेश दाजीमहाराजांचे स्मारक व समाधी मंदिर बनवावे जेणेकरून भक्तांना त्यांच्या दर्शनाचा लाभ चिरकाल पर्यंत मिळत राहील असा विचार करून श्रीमहाराजांची तत्कालीन प्रत्यक्ष कृपापात्र शिष्य मंडळी व महाराजांचे तृतीय चिरंजीव श्री.सिद्ध महाराज टाकळीकर यांनी सर्वांनी मिळून श्री महाराजांना 
                श्री नारायणबुवा केतकर यांनी गुरु सेवेमध्ये बांधून दिलेल्या वाड्यामध्ये महाराजांच्या नित्य बैठकीच्या स्थानावरच महाराजांच्या वस्त्र समाधी मंदिराची निर्मिती केली. त्या नंतर काही कालावधीतच गोदाकाठी श्रीदाजीमहाराजांचे अंत्यकार्य पार पडलेल्या दहनभूमीवर देखील शके १८८८-८९ मध्ये महाराजांचे समाधी मंदिर तत्कालीन संस्थानाधिपती श्री.सिद्धमहाराज व भक्तमंडळींनी मिळून निर्माण केले. व तिथे महाराजांच्या पादुकांची विधिवत स्थापना केली.
              </p>
             
            </div>
          </div>

          {/* Second  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container  comman-template-img-container-right">
              <img
                className="comman-template-image"
                src={sansthanImg.s_img02}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>कार्य परंपरा</h3>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; संस्थानाधिपती श्रीसिद्ध महाराजांच्या निर्याणानंतर संस्थानची धुरा ज्येष्ठ चिरंजीव श्री अनंतमहाराज टाकळीकर यांनी समर्थपणे सांभाळली. महामहोपाध्याय श्री.यज्ञेश्वर शास्त्री कस्तुरे तसेच काशी येथे अनेक विद्वान पंडितांच्या मार्गदर्शनाखाली संस्कृतचा गाढा अभ्यास श्री 
              अनंतमहाराजांनी पूर्ण केलेला होता परिसरामध्ये अनंतमहाराजांच्या उच्चकोटीच्या संस्कृत ज्ञानाची छाप पडत होती. श्रीदाजी महाराजांवर आधारित गद्य पद्यमय साहित्याच्या निर्मितीमध्ये श्री अनंतमहाराजांनी भरीव कामगिरी केली. नांदेड येथील भारत विद्यालय मधील शिक्षक म्हणून जबाबदारी सांभाळत त्यांनी संस्थानच्या कारभारावर देखील लक्ष ठेवून संस्थानची वृद्धी करण्यासाठी यथाशक्ती प्रयत्न केला. या दरम्यान श्री. अनंतमहाराजांना महाराष्ट्र शासनाचा आदर्श शिक्षक पुरस्कार देखील प्राप्त झाला. श्री आबासाहेब देशमुख पालमकर यांनी लिहिलेल्या श्री दाजीगुरु दर्शन या चरित्राचे प्रथम प्रकाशन व त्याची नीटनेटकी जुळवणी व मांडणी याचे श्रेय श्री 
              अनंतमहाराजांच्याकडे विशेषत्वाने जाते. त्याचबरोबर सद्गुरु भक्त मंडळींना एकत्र करून गुरुवार भजनी मंडळाची स्थापना करण्यातही अनंतमहाराजांचा मुलाचा वाटा आहे भजनी मंडळासाठी लागणारी आवश्यक महाराजांची भजने पदे व अभंग अशा अनेक रचना व त्याचबरोबर महाराजांच्या प्रचारार्थ महाराजांच्या जीवन चरित्रातील अनेक प्रसंगाचे कीर्तन आख्यान स्वरूपात देखील रचना श्री अनंतमहाराजांनी केल्या. त्याचबरोबर 
              दाजीमहाराजांपासून चालत आलेले चातुर्मास द्वादशी अन्नसंतर्पण व्रत, संस्थानाचे वार्षिक उत्सव महोत्सव हे सर्व कार्यक्रम श्री अनंतमहाराजांनी आपल्या शिस्तीसह चालू ठेवले.
              </p>
             
            </div>
          </div>


          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={sansthanImg.s_img04}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>उपक्रमशीलता</h3>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  संस्थानाच्या कार्य परंपरांचा वारसा पुढे समर्थपणे चालवण्याचे व्रत घेऊन संस्थानचे  सध्याचे संस्थानाधिपती विविध मूर्ती श्री उमेशमहाराज टाकळीकर. यांनी महाराजांच्या कार्यपरंपरेचा वारसा पुढे चालवण्यासाठी विशेष प्रयत्न सुरू केले व समीक्षेत्र टाकळी येथे संस्थानाच्या नित्य-नैमित्तिक सर्व उत्सव उपासना इत्यादी चालवत सोबतच श्री महाराजांची श्रीक्षेत्र टाकळी येथे वेदांच अध्ययन-अध्यापन कार्य करण्याच्या इच्छेवर विशेष लक्ष केंद्रित करून श्रीक्षेत्र धनगर टाकळी येथे अथक प्रयत्नातून चतुर्वेद वैदिक गुरुकुलाची उभारणी केली. महाराजांच्या चरित्र व कार्याच्या प्रचार प्रसार होता अनेक ग्रंथांचे प्रकाशन अनेक भव्य सोहळ्यांचा आयोजन तसेच दाजी महाराजांचे सिद्धी गुरू संतवर्ष गंगाजीबापूमहाराज यांच्या सेवार्थ स्वतंत्रपणे गोसेवा प्रकल्प देखील उभारला. गुरुकुलाच्या माध्यमातून अनेक वैदिक विद्वान घडवले व महाराजांच्या चरित्रकार्याचा प्रचार प्रसार श्री उमेशमहाराजांच्या कडून अविरतपणे चालू आहे
              </p>
             
            </div>
          </div>

          <div className="comman-template-sub-section"></div>
        </div>
      </div>
    </>
  );
};
